import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import FullScreenDialog from "components/FullScreenDialog";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { BarcodeScannerView } from "./BarcodeScannerView";

const PREFIX = "BarcodeScannerDialog";
const classes = {
  barCodeContainer: `${PREFIX}-barCodeContainer`,
};

const StyledFullScreenDialog = styled(FullScreenDialog)(() => ({
  [`& .${classes.barCodeContainer}`]: {
    marginTop: "15px",
    marginLeft: "3px",
  },
}));

interface BarcodeScannerDialogProps {
  submitValue: (value: string) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const BarcodeScannerDialog = (props: BarcodeScannerDialogProps) => {
  const { open, setOpen, submitValue } = props;
  const [isPermissionGranted, setIsPermissionGranted] = useState<boolean>();

  useEffect(() => {
    if (!open) return;
    navigator.mediaDevices
      .getUserMedia({ audio: false, video: true })
      .then((stream: MediaStream) => {
        stream.getTracks().forEach((t) => {
          t.stop();
        });
        setIsPermissionGranted(true);
      });
  }, [open]);

  return (
    <StyledFullScreenDialog
      child={
        isPermissionGranted ? (
          <BarcodeScannerView submitValue={submitValue} active={open} />
        ) : isPermissionGranted === false ? (
          <Container className={classes.barCodeContainer}>
            <Typography>
              <FormattedMessage id="barcode.allowCameraAccess" />!
            </Typography>
          </Container>
        ) : (
          <Container className={classes.barCodeContainer}>
            <Typography>Loading...</Typography>
          </Container>
        )
      }
      open={open}
      setOpen={(open: boolean) => {
        setOpen(open);
      }}
    />
  );
};
